// Injected into the shadow root — architecture.md §4.1: shadow DOM blocks host-page CSS leaks
// almost entirely; `:host { all: initial; }` strips inherited font/color properties too.
export const WIDGET_STYLES = `
  :host {
    all: initial;
    display: block;
    font-family: system-ui, -apple-system, sans-serif;
    color: #1a1a1a;
    background: #fff;
    max-width: 640px;
  }
  * { box-sizing: border-box; }
  .apc-form-row { margin-bottom: 8px; }
  .apc-url-input {
    width: 100%; padding: 10px 12px; font-size: 14px;
    border: 1px solid #ccc; border-radius: 6px; font-family: monospace;
  }
  .apc-form-intro { font-size: 13px; color: #555; margin-bottom: 12px; }
  .apc-add-field {
    background: none; border: none; color: #2563eb; cursor: pointer; font-size: 13px; padding: 4px 0;
  }
  .apc-consent-row { display: flex; align-items: center; gap: 8px; font-size: 13px; margin: 16px 0; }
  .apc-submit-button, .apc-cta-button {
    background: #16a34a; color: #fff; border: none; border-radius: 6px;
    padding: 12px 20px; font-size: 15px; font-weight: 600; cursor: pointer;
  }
  .apc-submit-button:hover, .apc-cta-button:hover { background: #15803d; }
  .apc-validation-error, .apc-error-message { color: #b91c1c; font-size: 13px; margin: 8px 0; }
  .apc-progress-list { list-style: none; padding: 0; margin: 16px 0; }
  .apc-progress-item { padding: 8px 0; border-bottom: 1px solid #eee; font-size: 14px; }
  .apc-status-badge { display: inline-block; padding: 2px 8px; border-radius: 10px; font-size: 12px; margin-right: 8px; }
  .apc-status-done { background: #dcfce7; color: #166534; }
  .apc-status-running, .apc-status-queued { background: #dbeafe; color: #1e40af; }
  .apc-status-timeout, .apc-status-bot_blocked, .apc-status-invalid_url { background: #fee2e2; color: #991b1b; }
  .apc-status-no_ads_found, .apc-status-cached { background: #f3f4f6; color: #4b5563; }
  .apc-score { font-size: 48px; font-weight: 700; display: inline-block; }
  .apc-score-max { font-size: 20px; color: #888; }
  .apc-report-header { display: flex; align-items: center; gap: 16px; margin-bottom: 16px; }
  .apc-finding { border: 1px solid #eee; border-radius: 8px; padding: 12px 16px; margin-bottom: 12px; }
  .apc-label-violation { border-left: 4px solid #dc2626; }
  .apc-label-notable { border-left: 4px solid #d97706; }
  .apc-label-info { border-left: 4px solid #6b7280; }
  .apc-finding-label { font-size: 11px; text-transform: uppercase; font-weight: 700; color: #555; }
  .apc-finding-title { margin: 4px 0; font-size: 15px; }
  .apc-finding-count { font-size: 12px; color: #6b7280; background: #f3f4f6; border-radius: 10px; padding: 2px 8px; }
  .apc-finding-explanation, .apc-finding-fix { font-size: 13px; color: #444; }
  .apc-finding-screenshot { max-width: 100%; border-radius: 4px; margin-top: 8px; }
  .apc-finding-instances { margin-top: 8px; font-size: 12px; color: #555; }
  .apc-finding-instances summary { cursor: pointer; color: #2563eb; }
  .apc-finding-instances ul { margin: 6px 0 0; padding-left: 18px; }
  .apc-finding-instances code { font-size: 11px; background: #f9fafb; padding: 1px 4px; border-radius: 3px; }
  .apc-adpresso-note { font-size: 12px; color: #16a34a; font-weight: 600; }
  .apc-disclaimer { font-size: 11px; color: #888; margin-top: 24px; }
  .apc-email-gate { border: 1px solid #ddd; border-radius: 8px; padding: 16px; margin: 16px 0; background: #fafafa; }
  .apc-email-input { padding: 8px 10px; font-size: 14px; border: 1px solid #ccc; border-radius: 6px; margin-right: 8px; }
  .apc-empty-state { text-align: center; padding: 40px 20px; color: #555; }
`;
